import React from 'react';
import { Sparkles, Zap, DollarSign, HandHeart } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const advantages = [
  {
    icon: <Sparkles className="w-12 h-12" />,
    title: 'Simple',
    description: 'Pas de termes compliqués. Je vous explique tout simplement et vous accompagne à chaque étape de votre projet.'
  },
  {
    icon: <Zap className="w-12 h-12" />,
    title: 'Rapide',
    description: 'Votre site avance vite et bien. Je m\u2019engage à livrer un site de qualité dans les délais prévus, sans compromis sur le résultat.'
  },
  {
    icon: <DollarSign className="w-12 h-12" />,
    title: 'Accessible',
    description: 'Des prix clairs et adaptés à votre budget. Un site professionnel ne doit pas coûter une fortune, surtout quand on démarre.'
  },
  {
    icon: <HandHeart className="w-12 h-12" />,
    title: 'Accompagnement',
    description: 'Je reste disponible même après la mise en ligne. Support, conseils et ajustements pour faire évoluer votre site avec votre activité.'
  }
];

const Advantages = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="advantages" className="py-16 sm:py-20 bg-gradient-to-br from-slate-50 to-white w-full overflow-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1E3A5F] mb-4">
            Pourquoi me choisir ?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Une approche simple et efficace pour créer votre site internet
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12">
          {advantages.map((advantage, index) => (
            <Card
              key={index}
              className="hover:shadow-xl transition-all duration-300 border-2 hover:border-[#FF9933]/30 bg-white"
            >
              <CardContent className="p-6 text-center">
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#FF9933]/10 text-[#FF9933] mb-4">
                  {advantage.icon}
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">
                  {advantage.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-600 leading-relaxed text-sm">
                  {advantage.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Box */}
        <div className="bg-gradient-to-r from-[#1E3A5F] to-[#2A4A6F] text-white rounded-2xl p-8 sm:p-12 text-center max-w-4xl mx-auto shadow-2xl">
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4">
            Prêt à voir votre site prendre forme ?
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-white/90 mb-6 max-w-2xl mx-auto">
            Parlons de votre projet et je vous crée une première ébauche gratuite pour que vous puissiez visualiser le résultat
          </p>
          <Button
            onClick={scrollToContact}
            className="bg-[#FF9933] hover:bg-[#E68A2E] text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Demander mon ébauche gratuite
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
